import React from 'react';
const $ = window.$;

export default class ConnectionFailureAlertUI extends React.Component {
    constructor(props) {
        super(props);

        this.alertRef = React.createRef();
    }
    componentDidUpdate(prevProps) {
        if (this.props.failedSavesCount === 0 && prevProps.failedSavesCount > 0) {
            $(this.alertRef.current).fadeOut(200);
        } else if (prevProps.connectionLost && !this.props.connectionLost) {
            $(this.alertRef.current).fadeOut(200);
        } else if (this.props.failedSavesCount > prevProps.failedSavesCount || (!prevProps.connectionLost && this.props.connectionLost)) {
            $(this.alertRef.current).fadeIn(200);
        }
    }

    renderMessage() {
        return <div className="message flex-grow-1" />;
    }

    onRetryClick() {
        $(this.alertRef.current).fadeOut(200);
        this.props.retrySave();
    }

    renderAction() {
        return (
            <div className="action d-flex" onClick={this.onRetryClick.bind(this)}>
                <i className="material-icons">refresh</i> Retry
            </div>
        );
    }

    render() {
        return (
            <div className="connection-failure-alert" ref={this.alertRef}>
                <div className="message-container d-flex align-items-center">
                    {this.renderMessage()}
                    {this.renderAction()}
                </div>
            </div>
        );
    }
}
